import localforage from 'localforage';
import FJUtil from '../util/FJUtil';

const _localforage = localforage.createInstance({
    name: 'image_manipulation_storage',
    version: 1.0,
    storeName: 'manipulation_cache',
    description: 'Image manipulation store at local storage.',
});

const FJImageManipulationStore = {
    /**
     * @desc 根据文件生成key
     * @param {Blob} blob
     * @returns {string} key
     */
    getKeyByBlob: async function (blob) {
        return await FJUtil.hashEncode(blob);
    },

    /**
     * @desc 获取本地存储的item
     * @param {string} key
     * @returns {Promise<string>} value
     */
    getLocalForageItem: async function (key) {
        return await _localforage.getItem(key);
    },

    /**
     * @desc 设置本地存储的item
     * @param {string} key
     * @param {string} value
     * @returns {Promise<void>}
     */
    setLocalForageItem: async function (key, value) {
        await _localforage.setItem(key, value);
    },

    /**
     * @desc 检查编辑图片是否已经上传s3
     * @param {string} editImageUrl
     * @returns {Promise<string | null>} s3Url
     */
    checkEditImageHasUploadS3: async function (editImageUrl) {
        const editImageBlob = await FJUtil.getBlobByUrl(editImageUrl);
        const editImageKey = this.getKeyByBlob(editImageBlob);

        const s3Url = await this.getLocalForageItem(editImageKey + '_s3');

        return s3Url;
    },
};
export default FJImageManipulationStore;
